// extracted by css-extract-rspack-plugin
export default {"form":"form-C5N5fK"};